import { render, staticRenderFns } from "./TheAccountRegister.vue?vue&type=template&id=5313047a&scoped=true&"
import script from "./TheAccountRegister.vue?vue&type=script&lang=js&"
export * from "./TheAccountRegister.vue?vue&type=script&lang=js&"
import style0 from "./TheAccountRegister.vue?vue&type=style&index=0&id=5313047a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5313047a",
  null
  
)

export default component.exports